
(function($){

	$.fn.mcubeGmapsAjax = function( options ){

		var defauts = {
			bounds:            true, // active le centrage automatiquement de la map afin d'afficher tous les points dans le viewport
			overlay:           true, // active l'apparition de la 'popup' au click sur le pointeur
			styles:            null,  // personnalisation des styles la map
			zoomControl:       true,
			scrollwheel:       false,
			streetViewControl: true,
			fullscreenControl: true,
			mapTypeControl:    true
		};

		var parametres = $.extend(defauts, options);
		var overlayActive = false;

		if( typeof GMaps == "undefined" ){
			console.log('ERREUR GMAPS : activer GMaps dans functions.php','#FA3348','#ffffff');
		}

		return this.each(function(){
			var $map                  = $(this);
			var map                   = false;
			var mapLat                = $map.data('lat');
			var mapLng                = $map.data('lng');
			var mapZoom               = ( $map.data('zoom') || 12 );
			var markers_item          = $('.coach-card');
			var markers               = [];
			var markers_search        = $('.coach-card--search');
			var markersSearch         = [];
			var isSearch              = false;
			var markerCluster         = null;
			var pointer               = $map.data('icon');
			var pointerHover          = $map.data('icon-hover');
			var pointerSize           = $map.data('icon-size');
			var pointerHoverSize      = $map.data('icon-hover-size');
			var pointerSearch         = $map.data('icon-search');
			var pointerSearchSize     = $map.data('icon-search-size');
			var pointerClusterer      = $map.data('icon-clusterer');
			var pointerClustererHover = $map.data('icon-clusterer-hover');

			var formatted_address      = null;
			var distanceBetweenMarkers = [];

			var bounds           = null;

			if( !mapLat ){
				console.log('ERREUR GMAPS : définir une latitude (data-lat)','#FA3348','#ffffff');
			}

			if( !mapLng ){
				console.log('ERREUR GMAPS : définir une longitude (data-lng)','#FA3348','#ffffff');
			}

			if( markers_item.length == 0 ){
				console.log('ERREUR GMAPS : aucun point de défini','#FA3348','#ffffff');
				console.log('<div class="map-markers" data-lat="" data-lng=""> contenu html </div>','#336bfa','#ffffff');
			}

	        var styles = [[{
		        url: pointerClusterer,
		        width: 30,
		        height: 30,
		        textColor: '#fff',
		        textSize: 12
		    }]];

			var options_clusterer = {
				styles: styles[0],
				enableRetinaIcons: true,
				showCluster: function(){
					console.log('Adding cluster');
				}
	        };

			map = new GMaps({
				div:               "."+$(this).attr('class'),
				zoom:              mapZoom,
				lat:               mapLat,
				lng:               mapLng,
				scrollwheel:       parametres.scrollwheel,
				zoomControl:       parametres.zoomControl,
				panControl:        true,
				streetViewControl: parametres.streetViewControl,
				fullscreenControl: parametres.fullscreenControl,
				mapTypeControl:    parametres.mapTypeControl,
				options:           {
					'styles': parametres.styles
				},
				tilesloaded: function() {
					// $('.sidebar--map').addClass('map-initialized');
				}
			});

			google.maps.event.addListener(map.map, 'idle', function(event){
				getNearestMarker(markersSearch[0]);
			});

			$('#zoom-in').on('click', function(e) {
				e.preventDefault();
				map.zoomIn(1);
			});
			$('#zoom-out').on('click', function(e) {
				e.preventDefault();
				map.zoomOut(1);
			});
			
			/* Fonctions au resize pour recentrer la map */
			google.maps.event.addDomListener(window, 'resize', function() {
				// if ( parametres.overlay && overlayActive ){
				// 	map.setCenter(marker_lat, marker_lng);
				// } else if( parametres.bounds && markers.length > 2 ){
				// 	map.panToBounds(bounds);
				// 	map.fitBounds(bounds);
				// }else if( markers.length == 2 ){
				// 	map.setCenter(markers[0].getPosition().lat(), markers[0].getPosition().lng());
				// 	map.setZoom( 13 );
				// }else{
				// 	map.setCenter(mapLat, mapLng);
				// }
			});

			$('#fit-to-bounds').on('click', function(e) {
				e.preventDefault();
				if( markersSearch.length > 0 ){
					map.setCenter( markersSearch[0].getPosition().lat(), markersSearch[0].getPosition().lng() );
					map.setZoom(13);
				}else{
					map.panToBounds(bounds);
					map.fitBounds(bounds);
				}
				map.removeOverlays();
				overlayActive = false;
			});

			/* Personnalisation du pointer */
			if( pointer ){
				if( !pointerSize ){
					console.log('ERREUR GMAPS : spécifier les dimensions du pointer (data-icon-size="WxH")','#FA3348','#ffffff');
				}
				imageSize   = pointerSize.split('x');
				imageWidth  = parseInt(imageSize[0]);
				imageHeight = parseInt(imageSize[1]);

				var icon = {
					url:        pointer,
					size:       new google.maps.Size( imageWidth , imageHeight ),
					origin:     new google.maps.Point( 0 , 0 ),
					anchor:     new google.maps.Point( imageWidth/2 , imageHeight ),
					scaledSize: new google.maps.Size( imageWidth , imageHeight )
				};
			}

			if( pointerHover ){
				if( !pointerHoverSize ){
					console.log('ERREUR GMAPS : spécifier les dimensions du pointer au survol (data-icon-hover-size="WxH")','#FA3348','#ffffff');
				}
				imageHoverSize   = pointerHoverSize.split('x');
				imageHoverWidth  = parseInt(imageHoverSize[0]);
				imageHoverHeight = parseInt(imageHoverSize[1]);

				var custom_iconHover = {
					url:        pointerHover,
					size:       new google.maps.Size( imageHoverWidth , imageHoverHeight ),
					origin:     new google.maps.Point( 0 , 0 ),
					anchor:     new google.maps.Point( imageHoverWidth/2 , imageHoverHeight ),
					scaledSize: new google.maps.Size( imageHoverWidth , imageHoverHeight )
				};
			}

	        function changeClusterIcon(the_marker, action){
				var clusters = markerCluster.getClusters();
				for( var i = 0, l = clusters.length; i <l ; i++ ) { // door de clusters heenlopen
		            for( var j=0, le = clusters[i].markers_.length; j < le; j++ ){ // door de markers heenlopen die in het cluster zitten
		                marker = clusters[i].markers_[j];
		                if(marker.id == the_marker.id) { // checken of we bij het juiste pieletje zijn
		                    clusters[i].clusterIcon_.styles_[0].url = (action == 'in') ? pointerClustererHover : pointerClusterer;
		                    clusters[i].updateIcon_();
		                }
		            }
		        }
			}

			function getUrlVars() {
				var vars = {};
				var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
					vars[key] = value;
				});
				return vars;
			}

			function updateUrlParameter( uri, key, value ) {

				// remove the hash part before operating on the uri
				var i = uri.indexOf('#');
				var hash = i === -1 ? ''  : uri.substr(i);
					 uri = i === -1 ? uri : uri.substr(0, i);

				var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
				var separator = uri.indexOf('?') !== -1 ? "&" : "?";

				if (uri.match(re)) {
					
					uri = uri.replace( re, '$1' + key + "=" + value + '$2');

				} else {

					uri = uri + separator + key + "=" + value;

				}

				return uri + hash;  // finally append the hash as well
			}

			var addMarkersSearch = function(lat, lng){

				for (var i = 0; i < markersSearch.length; i++) {
					markersSearch[i].setMap(null);
				}
				markersSearch = [];
				var $this = $('.coach-card--search');

				var custom_icon_url  = pointerSearch;
				var custom_icon_size = pointerSearchSize.split('x');
				imageSearchWidth  = parseInt(custom_icon_size[0]);
				imageSearchHeight = parseInt(custom_icon_size[1]);

				var custom_icon = {
					url:        custom_icon_url,
					size:       new google.maps.Size( imageSearchWidth , imageSearchHeight ),
					origin:     new google.maps.Point( 0 , 0 ),
					anchor:     new google.maps.Point( imageSearchWidth/2 , imageSearchHeight ),
					scaledSize: new google.maps.Size( imageSearchWidth , imageSearchHeight )
				};

				var myMarkerSearch = map.addMarker({
					lat:     lat,
					lng:     lng,
					icon:    custom_icon
				});
				markersSearch.push( myMarkerSearch );
				if( markers.length === 0 ){
					addMarkers();
				}

			};

			var getGeocode = function( searchValue ){

				searchValue = searchValue.split(' ').join('+');
				isSearch = true;

				GMaps.geocode({
					address: searchValue,
					region: 'fr',
					callback: function(results, status) {

						if ( status === "ZERO_RESULTS" ){

							$('.search-summary').html("<span>Votre recherche n'a pas aboutie</span>");
							$('.sidebar--map').removeClass('map-initialized');
							$('.search-results').removeClass('search-loading');

						}else{

							latlng = results[0].geometry.location;
							latPoint = latlng.lat();
							lngPoint = latlng.lng();

							map.setCenter(latPoint, lngPoint);
							map.setZoom(13);

							addMarkersSearch(latPoint, lngPoint);


							formatted_address = results[0].formatted_address;

							window.history.replaceState( null, '', updateUrlParameter( window.location.href, 'optisearch', searchValue ) );

						}

					}
				});

			};

			var addMarkers = function(){

				for (var i = 0; i < markers.length; i++) {
					markers[i].setMap(null);
				}
				markers = [];
				markers_item = $('.coach-card');
				map.removeOverlays();

				if( parametres.bounds ){
					bounds = new google.maps.LatLngBounds();
				}

				$.each(markers_item, function(i,program){

					$this           = $(this);
					var custom_icon = null;

					if ( $this.data('icon') ){

						var custom_icon_url  = $this.data('icon');
						var custom_icon_size = $this.data('icon-size').split('x');
						var imageWidth  = parseInt(custom_icon_size[0]);
						var imageHeight = parseInt(custom_icon_size[1]);

						custom_icon = {
							url:        custom_icon_url,
							size:       new google.maps.Size( imageWidth , imageHeight ),
							origin:     new google.maps.Point( 0 , 0 ),
							anchor:     new google.maps.Point( imageWidth/2 , imageHeight ),
							scaledSize: new google.maps.Size( imageWidth , imageHeight )
						};
					}


					var myMarker = map.addMarker({
						id:      $this.data('id'),
						lat:     $this.data('lat'),
						lng:     $this.data('lng'),
						content: $this.html(),
						icon:    ( custom_icon || icon ),
						click:   function(element){
							if( parametres.overlay && element.id > 0 ){
								mapLoadOverlay(element);
							}else{
								map.removeOverlays();
							}
						}
					});

					bounds.extend( myMarker.getPosition() );
					markers.push( myMarker );

				});

				markerCluster = new MarkerClusterer(map.map, markers, options_clusterer);

				$('.coach-card__inner').mouseenter(function() {
					var coach_id = $(this).data('id');
					for ( var i = 0; i< markers.length; i++) {
						if ( coach_id === markers[i].id) {
							changeClusterIcon(markers[i], 'in');
							markers[i].setIcon( custom_iconHover );
							break;
						}
					}
				});

				$('.coach-card__inner').mouseleave(function() {
					var coach_id = $(this).data('id');
					for ( var i = 0; i< markers.length; i++) {
						if ( coach_id === markers[i].id) {
							changeClusterIcon(markers[i], 'out');							
							markers[i].setIcon( icon );
							break;
						}
					}
				});

				if( isSearch ) return false;

				if ( parametres.bounds && markers.length >= 2 ) {
					map.panToBounds(bounds);
					map.fitBounds(bounds);
				} else {
					map.setCenter(markers[0].getPosition().lat(), markers[0].getPosition().lng());
					map.setZoom( 13 );
				}

			};

			if( getUrlVars().optisearch ){
				searchValue = getUrlVars().optisearch;
				$('input[name = "optisearch"]').val( searchValue.split('+').join(' ') ).trigger('keyup');
				getGeocode( searchValue );
			} else {
				addMarkers();
			}

			// Affichage des infos bulles
			var mapLoadOverlay = function(element){

				overlayActive = true;

				marker     = element;
				position   = marker.getPosition();
				marker_lat = position.lat();
				marker_lng = position.lng();

				contenu = '<div class="map-overlay"><div class="map-overlay-content"><a href="#" class="map-overlay-close">&times;</a>';
				contenu += '<div class="map-overlay-inner">'+marker.content+'</div>';
				contenu += '</div></div>';

				map.removeOverlays();

				map.setCenter(marker_lat, marker_lng);
				
				var imgLoad = imagesLoaded( $(contenu) );
				imgLoad.on( 'always', function() {
					map.drawOverlay({
						lat:              marker_lat,
						lng:              marker_lng,
						verticalAlign:    'top',
						verticalOffset:   -45,
						horizontalAlign:  'center',
						horizontalOffset: 0,
						layer:            'floatPane',
						content:          contenu
					});
				});

				$(document).on('click touchstart', '.map-overlay a:not(.map-overlay-close)', function(e) {
					e.preventDefault();
					console.log('link from marker');
					linkHandler( $(this) );
				});


				$(document).on('click touchstart', '.map-overlay-close', function(e) {
					e.preventDefault();
					map.removeOverlays();
					overlayActive = false;
				});
			};

			$('.search-box form').submit(function() {

				var $searchValue = $('input[name = "optisearch"]').val();
				
				if ( $searchValue === '') {
					return false;
				}

				$('.coach-cards').addClass('coach-cards--hidden');
				$('.sidebar--map').removeClass('map-initialized');
				$('.search-results').addClass('search-loading');

				setTimeout(function(){ getGeocode( $searchValue ); }, 600);
				return false;

			});

			var getNearestMarker = function( myMarkerSearch ){
				var cpt      = markers.length;
				distanceBetweenMarkers = [];

				for (var i = 0; i < markers.length; i++){

		            if (map.getBounds().contains(markers[i].getPosition())){
		            	$('.coach-cards[data-id='+markers[i].id+']').removeClass('coach-cards--hidden');
		            	if( myMarkerSearch )
		            		getDistance( myMarkerSearch, markers[i] );
		            } else {
		            	$('.coach-cards[data-id='+markers[i].id+']').addClass('coach-cards--hidden');
		            	cpt--;
		            }

		            if( i == markers.length - 1 ){

		        		if( cpt > 0 ){
		        			$('.sidebar--map').addClass('map-initialized');
							$('.search-results').removeClass('search-loading');
							getMaxDistance();
							return false;
		        		}

		        		if( cpt === 0 ){
	            			if( isSearch ) map.zoomOut(1);
	           				getNearestMarker();
		        		}

		           	}
		        }
			};

			var rad = function(x) {
				return x * Math.PI / 180;
			};

			var getDistance = function(p1, p2) {
				var R     = 6378137; // Earth’s mean radius in meter
				var dLat  = rad( p2.getPosition().lat() - p1.getPosition().lat() );
				var dLong = rad( p2.getPosition().lng() - p1.getPosition().lng() );
				var a     = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
				Math.cos(rad(p1.getPosition().lat())) * Math.cos(rad(p2.getPosition().lat())) *
				Math.sin(dLong / 2) * Math.sin(dLong / 2);
				var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
				var d = R * c;
				distanceBetweenMarkers.push(d);
			};

			var getMaxDistance = function(){
				var nbCoach = $('.coach-cards:visible').length;
				var sentence = '<span>'+nbCoach;
				sentence += ( nbCoach > 1 ) ? " coachs " : " coach ";
				sentence += "</span>";
				sentence += ( nbCoach > 1 ) ? " trouvés " : " trouvé ";
				if( distanceBetweenMarkers.length > 0 ){
					sentence += " dans un rayon de ";
					sentence += Math.round( Math.max.apply(Math, distanceBetweenMarkers)/1000 ) + " kms ";
					sentence += " de "+formatted_address;
				}
				$(".search-summary").html(sentence);
			};

		});
	};

})(jQuery);